import React, { useEffect, useState } from 'react';
import { getAgentRates, emailAgentRates } from "../service/agentRateService";


const AgentRates = () => {
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [agentRates, setAgentRates] = useState([]);

    const handleSelect = (idx) => {
        setAgentRates(prev => prev.map((agent, i) =>
            i === idx ? { ...agent, selected: !agent.selected } : agent
        ));
    };
        
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await getAgentRates();
                setAgentRates(Array.isArray(response.data) ? response.data : []);
            } catch (error) {
                console.error("Error fetching agent rates:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);


    const publishAgentRates = async () => {
        const confirmed = window.confirm('Are you sure you want to publish selected agent FX rates?');
        if (!confirmed) return;
        setLoading(true);
        setMessage('');
        const selectedAgents = agentRates.filter(a => a.selected);
        try {
            emailAgentRates(selectedAgents).then(response => {
                setMessage('Agent FX rates published successfully!');
                setLoading(false);
            }).catch(err => {
                setMessage('An error occurred while publishing.');
                setLoading(false);
            });
        } catch (err) {
            setMessage('An error occurred while publishing.');
        }
    };

    return (
        <div>
            <h2>Agent FX Rates</h2>
            <p>Below are all agents and their current FX rates. When you click "Publish Rates", all rates will be email to all agents.</p>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Select</th>
                        <th>Agent Name</th>
                        {/* <th>Product ID</th> */}
                        <th>From</th>
                        <th>To</th>
                        <th>FX Rate</th>
                        <th>Published Date</th>
                    </tr>
                </thead>
                <tbody>
                    {agentRates && agentRates?.map((agent, idx) => (
                        <tr key={idx}>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={!!agent.selected}
                                    onChange={() => handleSelect(idx)}
                                />
                            </td>
                            <td>{agent.agentName}</td>
                            {/* <td>{agent.productId}</td> */}
                            <td>{agent.currencyFrom}</td>
                            <td>{agent.currencyTo}</td>
                            <td>{Number(agent.rate).toFixed(4)}</td>
                            <td>{agent.ratePublishedDateTime ? new Date(agent.ratePublishedDateTime).toLocaleString() : ''}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button
                type="button"
                className="btn btn-warning float-right"
                style={{ marginRight: "8px" }}
                onClick={publishAgentRates}
                disabled={loading || !agentRates.some(a => a.selected)}
            >
                {loading ? 'Publishing...' : 'Publish Rates'}
            </button>
            {message && <div className="alert alert-info mt-3">{message}</div>}
        </div>
    );
};

export default AgentRates;
